(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
(function () {
  const DESKTOP_MIN = '(min-width: 990px)';
  const desktopMQ = window.matchMedia(DESKTOP_MIN);
  const DETAILS_SELECTOR = 'header details, .header details, .mega-menu details';

  function initHover() {
    document.querySelectorAll(DETAILS_SELECTOR).forEach(details => {
      if (details.__hoverInit) return;
      details.__hoverInit = true;

      let closeTimer = null;
      const summary = details.querySelector('summary');

      const open = () => {
        clearTimeout(closeTimer);
        details.classList.add('is-hover-open');
        details.open = true;
      };

      const close = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          details.classList.remove('is-hover-open');
          details.open = false;
        }, 180); 
      };

      details.addEventListener('mouseenter', open);
      details.addEventListener('mouseleave', close);
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', close);

      function onPointerDown(e) {
        if (desktopMQ.matches && (e.pointerType === 'mouse' || e.pointerType === 'pen')) {
          e.preventDefault();
        }
      }
      function onMouseDownFallback(e) {
        if (desktopMQ.matches) e.preventDefault();
      }

      if (summary) {
        summary.addEventListener('pointerdown', onPointerDown);
        summary.addEventListener('mousedown', onMouseDownFallback);
      }

      details.__hoverHandlers = { open, close, onPointerDown, onMouseDownFallback };
    });
  }

  function destroyHover() {
    document.querySelectorAll(DETAILS_SELECTOR).forEach(details => {
      if (!details.__hoverInit) return;
      const h = details.__hoverHandlers || {};
      details.removeEventListener('mouseenter', h.open);
      details.removeEventListener('mouseleave', h.close);
      details.removeEventListener('focusin', h.open);
      details.removeEventListener('focusout', h.close);

      const summary = details.querySelector('summary');
      if (summary) {
        summary.removeEventListener('pointerdown', h.onPointerDown);
        summary.removeEventListener('mousedown', h.onMouseDownFallback);
      }

      details.__hoverInit = false;
      delete details.__hoverHandlers;
      details.classList.remove('is-hover-open');
      details.open = false;
    });
  }

  function recheck() {
    if (desktopMQ.matches) initHover();
    else destroyHover();
  }

  if (desktopMQ.addEventListener) desktopMQ.addEventListener('change', recheck);
  else desktopMQ.addListener(recheck);
  document.addEventListener('DOMContentLoaded', recheck);
})();


  } catch(e) { console.error(e); }
})();
})();
